/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserProductivityList
 */
export interface UserProductivityList {
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityList
     */
    userEmployeeId: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityList
     */
    userLastName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityList
     */
    userFirstName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityList
     */
    departmentLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityList
     */
    shiftLabel: boolean;
}

/**
 * Check if a given object implements the UserProductivityList interface.
 */
export function instanceOfUserProductivityList(value: object): value is UserProductivityList {
    if (!('userEmployeeId' in value) || value['userEmployeeId'] === undefined) return false;
    if (!('userLastName' in value) || value['userLastName'] === undefined) return false;
    if (!('userFirstName' in value) || value['userFirstName'] === undefined) return false;
    if (!('departmentLabel' in value) || value['departmentLabel'] === undefined) return false;
    if (!('shiftLabel' in value) || value['shiftLabel'] === undefined) return false;
    return true;
}

export function UserProductivityListFromJSON(json: any): UserProductivityList {
    return UserProductivityListFromJSONTyped(json, false);
}

export function UserProductivityListFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProductivityList {
    if (json == null) {
        return json;
    }
    return {
        
        'userEmployeeId': json['userEmployeeId'],
        'userLastName': json['userLastName'],
        'userFirstName': json['userFirstName'],
        'departmentLabel': json['departmentLabel'],
        'shiftLabel': json['shiftLabel'],
    };
}

export function UserProductivityListToJSON(json: any): UserProductivityList {
    return UserProductivityListToJSONTyped(json, false);
}

export function UserProductivityListToJSONTyped(value?: UserProductivityList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEmployeeId': value['userEmployeeId'],
        'userLastName': value['userLastName'],
        'userFirstName': value['userFirstName'],
        'departmentLabel': value['departmentLabel'],
        'shiftLabel': value['shiftLabel'],
    };
}

